import React from 'react';
import { PaginationCarouselDots } from './pagination-dots/pagination-carousel-dots/pagination-carousel-dots';
import { PaginationDots } from './pagination-dots/pagination-dots';
import { PaginationOptimizedDots } from './pagination-dots/pagination-optimized-dots/pagination-optimized-dots';
import { PaginationItems } from './pagination-items';
import { PaginationNumbers, } from './pagination-numbers';
import { PaginationRange } from './pagination-range';
export const Pagination = () => React.createElement(React.Fragment, null);
Pagination.Numbers = PaginationNumbers;
Pagination.Items = PaginationItems;
Pagination.Range = PaginationRange;
Pagination.Dots = PaginationDots;
Pagination.CarouselDots = PaginationCarouselDots;
Pagination.OptimizedDots = PaginationOptimizedDots;
//# sourceMappingURL=pagination.js.map